import React from "react"
import {graphql, PageProps} from "gatsby"
import {GatsbyImage, getImage, IGatsbyImageData} from "gatsby-plugin-image"
import Helmet from "react-helmet"

function shuffle(array:any[]) {
    for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1)); // random index from 0 to i

        // swap elements array[i] and array[j]
        // we use "destructuring assignment" syntax to achieve that
        // you'll find more details about that syntax in later chapters
        // same can be written as:
        // let t = array[i]; array[i] = array[j]; array[j] = t
        [array[i], array[j]] = [array[j], array[i]];
    }

}
const NotFoundPage = ({data}:PageProps<any>) => {
  const artworks = data.allWpArtwork.nodes;
  shuffle(artworks);

  return (
    <div className={"page page-not-found page-default page-top-padding page-bottom-padding"}>
        <Helmet title={"404 Not found | galerie bernard jordan"} defer={false} >
            <meta name={"robots"} content={"noindex, nofollow"} />
        </Helmet>
            <div className="container">
                <h1 className={"h1 text-blue"}>Page non trouvée</h1>
                <div className="row">
                    <div className="col col-3">
                        <div className="artworks404">
                        {artworks.map((node:any,key:number)=> {
                                const gatsbyImageData = node.featuredImage?.node.gatsbyImage;
                                const image = getImage(gatsbyImageData) as IGatsbyImageData;
                                return <div key={key} className={"artworks404__item"}>
                                    <GatsbyImage image={image} alt={""} />
                                </div>
                            }
                        )}
                        </div>
                    </div>
                </div>
            </div>

    </div>
  )
}

export default NotFoundPage

export const query = graphql`
    query Page404 {
        allWpArtwork(limit: 64, sort: {date: ASC}) {
            nodes {
               featuredImage {
                   node {
                       gatsbyImage(
                                    aspectRatio: 1
                                    width: 96
                                    layout: FIXED
                                    placeholder: NONE
                                    formats: [AUTO, WEBP]
                                )
                        }
                }
            }
        }
}
`
